import { BrowserRouter as Router, Routes, Route } from "react-router";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import Login from "./pages/Authentication/Login";
import Register from "./pages/Authentication/Register";
import Dashboard from "./pages/Dashboard/Dashboard";
import Excursiones from "./pages/Excursiones/Excursiones";
import Reservas from "./pages/Reservas/Reservas";
import Clientes from "./pages/Clientes/Clientes";
import Finanzas from "./pages/Finanzas/Finanzas";
import Reportes from "./pages/Reportes/Reportes";
import Configuracion from "./pages/Configuracion/Configuracion";
import Profile from "./pages/Profile/Profile";
import NotFound from "./pages/OtherPage/NotFound";
import ProtectedRoute from "./routes/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from 'react-hot-toast';

export default function App() {
  return (
    <>
      <Toaster
        position="top-right"
        containerStyle={{
          zIndex: 100000
        }}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#333',
            color: '#fff',
          },
          success: {
            duration: 3000,
            style: {
              background: '#4aed88',
              color: '#fff'
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#4aed88',
            }
          },
          error: {
            duration: 4000,
            style: {
              background: '#ff4b4b',
              color: '#fff'
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#ff4b4b',
            }
          },
        }}
      />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Rutas protegidas: si no hay sesión se redirige al login */}
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index path="/" element={<Dashboard />} />
              <Route path="/excursiones" element={<Excursiones />} />
              <Route path="/reservas" element={<Reservas />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/finanzas" element={<Finanzas />} />
              <Route path="/reportes" element={<Reportes />} />
              <Route path="/configuracion" element={<Configuracion />} />
              <Route path="/profile" element={<Profile />} />
            </Route>

            {/* Rutas públicas de autenticación */}
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
            </Route>

            {/* Ruta para páginas no encontradas */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </AuthProvider>
    </>
  );
}